function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "desktop_small_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "desktop_small_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#desktop_small_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "desktop-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "desktop-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#desktop_small_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0 0.72265625)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.46484 0C0.657109 0 0 0.657109 0 1.46484L0 14.3555C0 15.1632 0.657109 15.8203 1.46484 15.8203L7.71707 15.8203L7.36445 17.0545C7.22285 17.5501 6.66777 17.9688 6.15234 17.9688L3.94531 17.9688C3.78352 17.9688 3.65234 18.0999 3.65234 18.2617C3.65234 18.4236 3.78352 18.5547 3.94531 18.5547L16.0547 18.5547C16.2165 18.5547 16.3477 18.4236 16.3477 18.2617C16.3477 18.0999 16.2165 17.9688 16.0547 17.9688L13.8477 17.9688C13.3322 17.9688 12.7771 17.55 12.6355 17.0545L12.2829 15.8203L18.5352 15.8203C19.3429 15.8203 20 15.1632 20 14.3555L20 1.46484C20 0.657109 19.3429 0 18.5352 0L1.46484 0ZM18.5352 0.585938C19.0198 0.585938 19.4141 0.980234 19.4141 1.46484L19.4141 11.7188L0.585938 11.7188L0.585938 1.46484C0.585938 0.980234 0.980195 0.585938 1.46484 0.585938L18.5352 0.585938ZM12.5218 17.9688L7.47816 17.9688C7.68766 17.7554 7.84746 17.4968 7.92785 17.2154L8.32645 15.8203L11.6735 15.8203L12.0721 17.2154C12.1525 17.4969 12.3123 17.7554 12.5218 17.9688ZM1.46484 15.2344C0.980195 15.2344 0.585938 14.8401 0.585938 14.3555L0.585938 12.3047L19.4141 12.3047L19.4141 14.3555C19.4141 14.8401 19.0198 15.2344 18.5352 15.2344L1.46484 15.2344Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.3633 9.96094C17.5251 9.96094 17.6563 9.8298 17.6563 9.66797L17.6563 0.292969C17.6563 0.131133 17.5251 0 17.3633 0L0.292969 0C0.131172 0 0 0.131133 0 0.292969L0 4.39453C0 4.55637 0.131172 4.6875 0.292969 4.6875C0.454766 4.6875 0.585938 4.55637 0.585938 4.39453L0.585938 0.585938L17.0703 0.585938L17.0703 9.375L0.585938 9.375L0.585938 5.56641C0.585938 5.40457 0.454766 5.27344 0.292969 5.27344C0.131172 5.27344 0 5.40457 0 5.56641L0 9.66797C0 9.8298 0.131172 9.96094 0.292969 9.96094L17.3633 9.96094Z",
  transform: "translate(1.171875 1.171875)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0.878906C0 1.36352 0.394258 1.75781 0.878906 1.75781C1.36355 1.75781 1.75781 1.36352 1.75781 0.878906C1.75781 0.394297 1.36355 0 0.878906 0C0.394258 0 0 0.394297 0 0.878906ZM0.585938 0.878906C0.585938 0.717344 0.717344 0.585938 0.878906 0.585938C1.04047 0.585938 1.17188 0.717344 1.17188 0.878906C1.17188 1.04047 1.04047 1.17188 0.878906 1.17188C0.717344 1.17188 0.585938 1.04047 0.585938 0.878906Z",
  transform: "translate(9.121094 12.890625)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))));

var SvgDesktop = function SvgDesktop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDesktop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/desktop.34145919.svg";
export { ForwardRef as ReactComponent };